import {
  Modal,
  TextInput,
  CallBackSelectorWithOptions,
  TextAreaInput,
  InputSelect,
  NumberInput,
} from '@wajeez-web/components/ui';
import React, { useState, useEffect } from 'react';
import { AxiosResponse } from 'axios';
import { CommonModalProps } from './Types';

export interface SectionInputProps {
  title: string;
  sectionType: number;
  collectionRowId: number;
  span: number;
  description: string;
  endpointId: number;
}
export const setionTypeOptions = [
  { label: 'Chart', value: 0 },
  { label: 'ChartStats', value: 1 },
  { label: 'ChartTable', value: 2 },
  { label: 'Stats', value: 3 },
  { label: 'Table', value: 4 },
];

interface SectionModalProps extends CommonModalProps<SectionInputProps> {
  allEndPoints: { id: string; title: string }[];
}

const SectionModal: React.FC<SectionModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  data,
  allEndPoints,
}) => {
  const [values, setValues] = useState<SectionInputProps>({
    title: '',
    sectionType: 0,
    collectionRowId: -1,
    span: 0,
    description: '',
    endpointId: -1,
  });

  useEffect(() => {
    data && setValues(data);
  }, [data]);

  const onChange = (name: string, value: string | number) => {
    setValues({ ...values, [name]: value });
  };
  return (
    <Modal
      title={''}
      open={isOpen}
      onClose={onClose}
      onSubmit={() => onSubmit && onSubmit(values)}
    >
      <div className="space-y-2">
        <TextInput
          name="title"
          label="Title"
          value={values.title}
          onChange={onChange}
        />
        <TextAreaInput
          name="description"
          label="Description"
          value={values.description}
          onChange={onChange}
        />
        <NumberInput
          name="span"
          label="Span"
          value={values.span}
          onChange={onChange}
        />
        <InputSelect
          options={setionTypeOptions}
          name="sectionType"
          label="Section Type"
          value={setionTypeOptions.find(
            (item) => item.value === values.sectionType
          )}
          onChange={(name, value: any) => onChange(name, value.value)}
        />
        <CallBackSelectorWithOptions
          getOptions={() =>
            Promise.all(
              allEndPoints.map((item: { id: string; title: string }) => ({
                label: item.title,
                value: item.id,
              }))
            ).then((res) => res[0])
          }
          name="endpointId"
          label="Endpoint Id"
          value={values.endpointId}
          onChange={(name, value: any) => onChange(name, value.value)}
        />
        {/* <CallBackSelectore
            getOptions={() =>
              TemplateServices.getTamplateRows(1).then(({ data }) =>
                data?.map((item: { id: number }) => ({
                  label: item.id,
                  value: item.id,
                }))
              )
            }
            name="collectionRowId"
            label="Collection Row Id"
            onChange={(name, value: any) => onChange(name, value.value)}
          /> */}
      </div>
    </Modal>
  );
};

export default SectionModal;
